<div class="ui-button " :class="styleAll">
  <button :for="forVal" :id="id" class="btn-item btn-default GTM__Button" :disabled="state.disable" :class="styleClass"
    @click.prevent="onClick">
    <slot v-if="custom" :name="custom"></slot>
    <span class="icon-block" v-if="icon">
      <iCon :iconClass="icon" class="icon-item"></iCon>
    </span>
    <div class="text">{{text}}</div>
  </button>
</div>